import { Organization } from "@/model/data/organizations/Organization";
import { AxiosResponse } from "axios";
import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { ServiceResponseData } from "../ServiceResponseData";

const ENDPOINT = "/organizations";

export class GetOrganizationsCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";

    constructor() {
        super();
    }

    public async execute(): Promise<GetOrganizationsResData> {
        let res = await this.executeCommand();
        return new GetOrganizationsResData(res);
    }
}

export class GetOrganizationsResData extends ServiceResponseData {
    organizations: Organization[] = [];

    constructor(response: AxiosResponse) {
        super(response);
        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.Organizations && obj.Organizations.length > 0) {
            this.organizations = [];
            obj.Organizations.forEach((obj) => {
                let temp = new Organization();
                temp.parse(obj);
                this.organizations.push(temp);
            });
        }
    }
}
